export const PrimaryColor = '#333'
export const PrimaryLight = '#fff'
export const PrimaryDark = '#000000de'

export const OffWhite = '#EAEAEA'
export const ProgressColor = '#f11946'

export const ThemeColorDark = 'hsl(0, 100%, 50%)'
export const ThemeColorLight = 'hsl(0, 100%, 55%)'

export const DefaultImage = 'https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg?20200913095930'